var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 60,
    height: 60,
    rx: 10,
    fill: "#002FA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1198 26.75C41.901 26.75 45 28.2227 45 30C45 31.8281 41.901 33.25 40.1198 33.25H34.0469L28.8125 42.1824C28.5156 42.6902 27.9635 43 27.3646 43H24.4375C23.8854 43 23.4844 42.482 23.6354 41.9641L26.1875 33.25H20.8333L18.5833 36.175C18.4271 36.3781 18.1771 36.5 17.9167 36.5H15.7292C15.3229 36.5 15 36.1801 15 35.7891C15 35.723 15.0104 35.657 15.026 35.591L16.6667 30L15.026 24.409C15.0052 24.343 15 24.277 15 24.2109C15 23.8148 15.3281 23.5 15.7292 23.5H17.9167C18.1771 23.5 18.4271 23.6219 18.5833 23.825L20.8333 26.75H26.1927L23.6406 18.0359C23.4844 17.518 23.8854 17 24.4375 17H27.3646C27.9635 17 28.5156 17.3148 28.8125 17.8176L34.0469 26.75H40.1198V26.75Z",
    fill: "#002FA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.961652bf60464b4b37c8babb06062a7b.svg";
export { ForwardRef as ReactComponent };